import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Location } from 'models/location';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenericModalService } from '../../generic-modal';

@Component({
    selector: 'da-hotel',
    templateUrl: './hotel.component.html',
    styleUrls: ['./hotel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HotelComponent implements OnInit {
    @Input() location: Location;
    @ViewChild('overlay', { static: true }) private _overlay;
    private _modalId: string;
    public courseImage: string;
    public alt: string;

    private _$list: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    public get list$(): Observable<any> {
        return this._$list.asObservable();
    }

    private _$courseImage: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);

    public get courseImage$(): Observable<{}> {
        return this._$courseImage.asObservable();
    }

    constructor(private _genericModalService: GenericModalService) {}
    ngOnInit() {
        if (this.location && this.location.image) {
            if (this.location.image.uri) {
                this.courseImage = environment.APIEndpoint + this.location.image.uri;
                this._$courseImage.next(this.courseImage);
            }
            if (this.location.image && this.location.image.fileName) this.alt = this.location.image.fileName;
        }
    }

    public openOverlay(city: any): void {
        this._overlayHandler();

        this._$list.next(this.location.hotels);
    }

    private _overlayHandler(): void {
        this._modalId = this._genericModalService.create(this._overlay);
        this._genericModalService.open(this._modalId, this._overlay);
    }

    public closeModal() {
        this._genericModalService.close(this._modalId);
    }
}
